import React, {Fragment} from "react";
import {postData, sendRequest} from "../../../utils/request";
import Portal from "../../layout/Portal";
import Modal from "../../layout/Modal";
import StockEditor from "../stockEditor";
import FragmentEditor from "../FragmentEditor";
import SelectorGrid from "../../form/SelectorGrid/SelectorGrid";
import Select from "../../form/Select";
import Icon from "../../form/Icon";
import connect from "react-redux/es/connect/connect";
import {get, set} from "../../../utils/dotutils";
import TextInput from "../../form/TextInput";
import ComponentLoader from "../../form/ComponentLoader";
import Button from "../../form/Button";
import {createComponent} from "../../../utils/components";
import ContentLoader from "../../layout/ContentLoader";

class OperationListType extends React.Component {

    state = {
        opened: false
    }

    render() {

        let item = this.props.product;
        const fields = {"qty": "qty", "listprice": "listprice", "saleprice": "saleprice", "vat": "vat.id"};
        /*if (item.hasOwnProperty("reserved")) {
            item.qty = item.qty - (item.reserved || 0);
        }*/
        item = {...Object.keys(fields).reduce((a,b)=> (set(a,b, get(item, fields[b], undefined)),a),{})};
        item.component_type = "product";
        item.component_id = this.props.productId;

        const AmountModal = (action, OperationItem) => <Portal>
            <Modal
                header={OperationItem ? "Módosítás" : "Hozzáadás"}
                size="small"
                state={this.state.opened}
                buttons={[
                    {
                        text: "Mégse",
                        props: {color: "default", disabled: this.props.disabled || this.props.isLoading || this.state.isLoading},
                        onClose: true,
                        onClick: async () => {
                            try {
                                this.setState({opened: false, amount: null});
                            } catch (e) {

                            }
                        }
                    },
                    {
                        text: "Mehet",
                        props: {color: "primary", disabled: this.props.disabled || this.props.isLoading || this.state.isLoading || !this.state.amount || this.state.amount > this.props.stock.qty},
                        onClick: action
                    }
                ]}
            >
                <div className="row form-row">
                    <div className="col-md-12 currency">
                        <TextInput
                            type="number"
                            name="amount"
                            label="Mennyiség"
                            value={this.state.amount}
                            onKeyDown={(e, field, value) => this.setState({[field]: value <= this.props.stock.qty ? value : this.state.amount})}
                            onBlur={(e, field, value) => this.setState({[field]: value <= this.props.stock.qty ? value : this.state.amount})}
                            saveChanges={(field, value) => this.setState({[field]: value <= this.props.stock.qty ? value : this.state.amount})}
                        />
                    </div>
                </div>
            </Modal>
        </Portal>;

        if (this.props.value.length) {
            return (
                <div className="selector-grid returngoods">
                    {
                        this.props.value.map((OperationList) => {
                            return <Fragment>
                                <ComponentLoader dynamic={true} componentName="OperationItem" filter={[{field: "OperationList_id", value: OperationList.id},{field: "component_type", value: "product"},{field: "component_id", value: this.props.productId}]}>
                                    {(props) => {
                                        return <Fragment>
                                            {AmountModal(async () => {
                                                try {
                                                    this.setState({isLoading: true});
                                                    let actionparams = {
                                                        parentcomponent: "OperationList",
                                                        listfield: "items",
                                                        parentid: OperationList.id,
                                                        action: "componentlist." + (!(props.OperationItem || {}).id ? "addItemsToList" : "updateItems"),
                                                        items: [{...item, saleprice: item.saleprice !== undefined ? item.saleprice : item.listprice, qty: this.state.amount, id: (props.OperationItem || {}).id}]
                                                    };
                                                    await postData(actionparams);
                                                    this.props.selectorgrid.refresh();
                                                    this.setState({opened: false, isLoading: false, amount: null});
                                                } catch (e) {
                                                    console.error(e);
                                                }
                                            }, props.OperationItem)}
                                            <Button
                                                size="xs"
                                                color="primary"
                                                onClick={() => this.setState({opened: true, amount: props.OperationItem.qty || this.props.stock.qty})}
                                                icon={props.OperationItem.qty ? null : {lib: "fas", name: "plus"}}
                                                tooltip={props.OperationItem.qty ? props.OperationItem.qty + "db van " + (OperationList.label || "a") + " listán" : "Hozzáadás " + (OperationList.label || "a") + " listához"}
                                            >
                                                {props.OperationItem.qty ? props.OperationItem.qty + " db" : null}
                                            </Button>
                                        </Fragment>
                                    }}
                                </ComponentLoader>
                            </Fragment>;
                        })
                    }
                    <div className="clearfix"/>
                </div>
            );
        } else if (!this.props.loading) {
            return <Fragment>
                {AmountModal(async () => {
                    try {
                        this.setState({isLoading: true});
                        await createComponent("OperationList", {
                            preset: "ReturnGoods",
                            data: {
                                source: this.props.stock.store.id,
                                target: this.props.store.id,
                                saved: 1,
                                xtradata: {return: true},
                                label: this.props.pos.name + " visszáru",
                                items: [{...item, saleprice: item.saleprice !== undefined ? item.saleprice : item.listprice, qty: this.state.amount}]
                            }
                        }, "default");
                        this.props.selectorgrid.refresh();
                        this.setState({opened: false, isLoading: false, amount: null});
                    } catch (e) {
                        console.error(e);
                    }
                })}
                <Button
                    size="xs"
                    color="warning"
                    onClick={() => this.setState({opened: true, amount: this.props.stock.qty})}
                    icon={{lib: "fas", name: "plus"}}
                    tooltip="Új visszaáru"
                />
            </Fragment>;
        } else {
            return <ContentLoader />;
        }
    }
}

const operationListModals = [];
let franchiseRequest = null;
let franchiseList = null;

class OperationListModal extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            opened: false,
            loading: false,
            franchiseList
        };
    }

    componentDidMount() {
        operationListModals.push(this);
        this.loadFranchiseList();
    }

    componentWillUnmount() {
        if (operationListModals.indexOf(this) !== -1) {
            operationListModals.splice(operationListModals.indexOf(this), 1);
        }
    }

    loadFranchiseList = async () => {
        if (!this.state.franchiseList && this.props.pos) {
            if (!franchiseRequest) {
                franchiseRequest = sendRequest({
                    option: "componentlist",
                    component: "FranchisePartner",
                    view: {"franchise": {"id": ""}},
                    filter: {field: "partner_id", value: this.props.pos.partner.partner_id},
                    itemsperpage: 0,
                });
                franchiseRequest.then((data) => {
                    const franchiseIds = data.items.map((item) => {
                        return item.franchise.id
                    });
                    sendRequest({
                        option: "componentlist",
                        component: "Franchise",
                        view: {"partners": {"partner_id": ""}},
                        filter: {field: "id", value: franchiseIds, operator: "in"},
                        itemsperpage: 0,
                    }).then((data) => {
                        franchiseList = [].concat.apply([], data.items.map((item) => {
                            return item.partners.map((p) => p.partner_id);
                        }));
                        operationListModals.map((o) => o.setState({
                            franchiseList
                        }));
                    });
                });
            }
        }
    }

    render() {
        const findFilter = (items) => {
            return [].concat.apply([], items.map((item) => {
                if (item.token.indexOf("Return") !== -1) {
                    return item;
                } else if(item.items) {
                    return findFilter(item.items);
                } else {
                    return null;
                }
            }).filter((item) => !!item));
        }
        const findMenuItem = (find, items) => {
            return items.map((item) => {
                if (item.token === find) {
                    return item;
                } else if(item.items) {
                    return findMenuItem(find, item.items);
                } else {
                    return null;
                }
            }).find((item) => !!item);
        }
        const options = findFilter(this.props.menu.items);
        let button = <a
            href="#"
            onClick={(e) => {e && e.preventDefault(); e && e.stopPropagation(); this.setState({opened: true})}}>
            <Icon lib="fas" name="truck-loading" tooltip="Visszáru" />
        </a>;
        if (this.props.children) {
            if (this.props.children instanceof Function) {
                button = this.props.children({onClick: (e) => {e && e.preventDefault(); e && e.stopPropagation(); this.setState({opened: true})}});
            } else {
                button = React.Children.map(this.props.children, (child) => {
                    return <child.type {...{
                        ...child.props,
                        onClick: (e) => {e && e.preventDefault(); e && e.stopPropagation(); this.setState({opened: true})}
                    }} />
                });
            }
        }
        return (
            <Fragment>
                {this.state.opened && <Portal>
                    <Modal
                        state="on"
                        size="large"
                        header={this.props.product.displayname + " Készlet"}
                        closeAble={!this.state.loading}
                        buttons={[
                            {
                                text: 'Bezárás',
                                props: {color: "default", disabled: this.props.disabled || this.props.isLoading || this.state.loading},
                                onClose: true,
                                onClick: async () => {
                                    try {
                                        this.setState({opened: false});
                                    } catch (e) {

                                    }
                                }
                            },
                        ]}
                    >
                        <div className="form-group">
                            <label className="control-label">Készlet</label>
                            <StockEditor
                                gridid={null}
                                list={FragmentEditor}
                                partner_id={this.state.franchiseList}
                                product_id={this.props.productId}
                                store_id={this.props.pos.store.id}
                                removeColumns={(columns) => {
                                    delete columns.displayname;
                                    return columns
                                }}
                                plusColumns={{
                                    action: {
                                        header: 'Visszáru',
                                        width: 1,
                                        renderer: (value, rowData) => {
                                            return <SelectorGrid
                                                type={
                                                    (props) =>
                                                        <OperationListType
                                                            {...props}
                                                            pos={this.props.pos}
                                                            productId={this.props.productId}
                                                            product={this.props.product}
                                                            stock={rowData}
                                                            store={this.props.pos.store}
                                                        />
                                                }
                                                onLoadCompleted={(response) => {
                                                    if (Object.keys(response).length) {
                                                        response = {...response};
                                                        response.rows = [...response.rows].map((row) => {
                                                            row.product = this.props.product
                                                            return row;
                                                        });
                                                    }
                                                    return response;
                                                }}
                                                component="OperationList"
                                                filter={[
                                                    {
                                                        field: "created_by",
                                                        value: this.props.user.id
                                                    },{
                                                        field: "preset",
                                                        value: "ReturnGoods",
                                                        operator: "like"
                                                    },{
                                                        field: "saved",
                                                        value: 1
                                                    },{
                                                        field: "source",
                                                        value: rowData.store.id
                                                    }
                                                ]}
                                                view={["label"]}
                                                columns={{
                                                    "preset": {
                                                        header: 'Típus',
                                                        width: 2,
                                                        filterable: <Select
                                                            storeType="local"
                                                            options={options}
                                                            label={false}
                                                            objectValue={false}
                                                            isClearable={true}
                                                            valueKey="token"
                                                            labelKey="label"
                                                        />,
                                                        renderer: (value) => ((findMenuItem(value, this.props.menu.items || []) || {}).label || value)
                                                    },
                                                }}
                                            />
                                        }
                                    }
                                }}
                            />
                        </div>
                    </Modal>
                </Portal>}
                {!!(this.state.franchiseList || []).length && !!options.find((item) => item.token === "ReturnGoods") && button}
            </Fragment>
        );
    }
}

const OperationListStock = connect((state) => {
    return {
        user: state.app.user,
        pos: state.app.till.pos,
        menu: state.app.template.menu
    }
})(OperationListModal);

export default OperationListStock;